import React, { useEffect, useRef, useState } from "react";
import style from "./style.module.scss";
import { Assets } from "../../../assets";
import Spinner from "../Spinner/Spinner";
import { UploadService } from "../../services/upload";
import { createFormData } from "../../../utilities/formData";
import { HttpStatusCode } from "axios";
import { FormInstance, Popover } from "antd";
import { AiOutlineDelete } from "react-icons/ai";

type ValueType = {
  label: string;
  value: string;
  key?: string;
};

type DynamicUploadFileType = {
  form?: FormInstance;
  onChange?: (value: any) => void;
  name: string;
  value?: ValueType;
  readOnly?: boolean;
};

const initialValue = {
  label: "",
  value: "",
  key: null,
};

export const DynamicUploadFile = ({
  name,
  form,
  readOnly = false,
}: DynamicUploadFileType) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [initialState, setInitialState] = useState<any>(
    form?.getFieldValue(name) ?? initialValue
  );

  useEffect(() => {
    setInitialState(form?.getFieldValue(name));
  }, [form?.getFieldValue(name)]);

  const handleFileClick = () => {
    !readOnly && fileInputRef.current?.click();
  };

  const handleClosePopOver = () => {
    setOpen((prev: boolean) => !prev);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      handleUploadTheFile({ file });
    }
  };

  const handleClickOnDelete = () => {
    if (!readOnly) {
      form?.setFieldValue(name, "");
      setInitialState(initialValue);
    }
  };

  const handleUploadTheFile = async (e: { file: File }) => {
    try {
      setIsLoading(true);
      const res = await UploadService.uploadFile(createFormData(e));
      if (
        res?.status === HttpStatusCode.Created ||
        res?.status === HttpStatusCode.Ok
      ) {
        const formated = {
          label: res?.data?.basename,
          value: res?.data?.["@id"],
          key: res?.data?.contentUrl,
        };
        setInitialState(formated);
        if (form && name) {
          form && form.setFieldValue(name, formated);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className={style.dynamic_upload__wrapper}>
        <div className={style.dynamic_upload__content}>
          <div className="">
            {!initialState?.value ? (
              <></>
            ) : (
              <div className={style.dynamic_upload__name_content}>
                {initialState?.key ? (
                  <a
                    href={initialState?.key}
                    target="_blank"
                    download
                    className={style.dynamic_upload__name}
                  >
                    {initialState?.label}
                  </a>
                ) : (
                  <span className={style.dynamic_upload__name}>
                    {initialState?.label}
                  </span>
                )}
                {!readOnly && (
                  <Popover
                    content={
                      <div className={style.dynamic_upload__delete_footer}>
                        <button
                          onClick={handleClosePopOver}
                          className={style.dynamic_upload__delete_cancel_btn}
                        >
                          Annuler
                        </button>
                        <button
                          onClick={handleClickOnDelete}
                          className={style.dynamic_upload__delete_confirm_btn}
                        >
                          Oui
                        </button>
                      </div>
                    }
                    title={
                      <span className={style.dynamic_upload__delete_text}>
                        Supprimer le fichier ?
                      </span>
                    }
                    trigger="click"
                    open={open}
                    onOpenChange={handleClosePopOver}
                  >
                    <span
                      className={style.dynamic_upload__delete}
                      // onClick={handleClickOnDelete}
                    >
                      <AiOutlineDelete
                        title="Supprimer"
                        className={style.dynamic_upload__delete_icon}
                      />
                    </span>
                  </Popover>
                )}
              </div>
            )}
          </div>
          {isLoading ? (
            <Spinner color="rgb(211, 208, 208)" />
          ) : (
            <img
              src={Assets.images.attach}
              alt=""
              className={style.dynamic_upload__image}
              style={{
                backgroundColor: readOnly ? "grey" : "red",
                cursor: readOnly ? "not-allowed" : "pointer",
              }}
              onClick={handleFileClick}
            />
          )}
        </div>
        <input
          type="file"
          className={"d-none"}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </div>
    </>
  );
};
